import { Component, OnInit, DoCheck, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { IRteListButtonItem, RTEAlertService } from 'rte-library';
import { Provider } from '@angular/core/src/render3/jit/compiler_facade_interface';
import { TestConnection } from 'src/app/reports/models/query/test-connection.model';
import { QueryService } from 'src/app/reports/services/query.service';
import { BaseComponent } from 'src/app/reports/shared/utils/base.component';

@Component({
  selector: 'app-test-connection',
  templateUrl: './test-connection.component.html',
  styleUrls: ['./test-connection.component.scss']
})
export class TestConnectionComponent extends BaseComponent implements OnInit, DoCheck {

  //#region Properties

  @Input() provider: Provider;

  connectionActions: Array<IRteListButtonItem> = new  Array<IRteListButtonItem>();
  connectionButton: IRteListButtonItem;

  testDisable: boolean;

  //#endregion

  constructor(
    private queryService: QueryService,
    private alert: RTEAlertService) {
      super();
    }

  ngOnInit() {
  }

  ngDoCheck() {
    this.verifyIfEnableConnectionButton();
  }

  //#region Init Methods

  //#endregion

  verifyIfEnableConnectionButton() {
    const action: boolean = this.isProviderTypeValid(this.provider.ProviderType) && !!this.provider.ConnectionString;

    this.enableConnectionButton(action);
  }

  enableConnectionButton(action: boolean) {
    this.testDisable = !action;
  }

  isProviderTypeValid(value: any): boolean {
    return value || value === 0;
  }

  getTestConnectionObject(): TestConnection {
    return  {
      ConnectionString : this.provider.ConnectionString,
      ProviderType : this.provider.ProviderType
    };
  }

  testConnectionOnClickButton(obj: TestConnection) {
    if (obj && obj.ConnectionString && this.isProviderTypeValid(obj.ProviderType)) {
      this.subscription.add(
        this.queryService.testConnection(obj).subscribe(result => {
          if (!result.Success) {
            this.alert.error('Erro ao estabelecer a conexão com o provedor', result.Message, {expanded: true});
          } else {
            this.alert.success(result.Message, '');
          }
        })
      );
    }
  }
}
